import { oz } from '@weft/utils';

export const SanitizedStringSchema = oz.string().trim().min(1, 'required');

export type SanitizedString = oz.infer<typeof SanitizedStringSchema>;